export default __webpack_public_path__ + "static/media/landpage.4a74de59.svg";